import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections';
import type { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import type { AudienceListType, FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types';
import { SelectFlatSegments } from '../../drawer/components/SelectFlatSegments';
import { LocationSegmentsList } from './LocationSegmentsList';
import { createSegmentDeleteHandler } from './utils/createSegmentDeleteHandler';

export type LocationDmaProps = {
  listType: AudienceListType;
  locationDmaSegments: FormSegment[];
  setLocationDmaSegments: Dispatch<SetStateAction<FormSegment[]>>;
  options: FormSegment[];
  isEdit?: boolean;
};

export const LocationDma = ({
  listType,
  locationDmaSegments,
  setLocationDmaSegments,
  options,
  isEdit = false,
}: LocationDmaProps) => {
  const { t } = useTranslation();

  return (
    <IndentedSections>
      {isEdit && (
        <SelectFlatSegments
          options={options}
          label={t('DMA')}
          placeholder={t('[ Select or Search DMA ]')}
          selectedSegments={locationDmaSegments}
          dataTest="dma-list"
          setSelectedSegments={setLocationDmaSegments}
        />
      )}

      {locationDmaSegments.length > 0 && (
        <LocationSegmentsList
          listType={listType}
          locationSegments={locationDmaSegments}
          onSegmentDelete={createSegmentDeleteHandler(locationDmaSegments, setLocationDmaSegments)}
          dataTest="dma"
        />
      )}
    </IndentedSections>
  );
};
